<template>
  <a-config-provider :locale="enUS" global>
    <router-view></router-view>
  </a-config-provider>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
import useStore from '@/store';

// 导入语言包
import zhCn from '@arco-design/web-vue/es/locale/lang/zh-cn';
import en from '@arco-design/web-vue/es/locale/lang/en-us';
import pt from '@arco-design/web-vue/es/locale/lang/pt-pt';
import ru from '@arco-design/web-vue/es/locale/lang/ru-ru';

// 语言包map
const languageMap = {
  'zh-cn': zhCn,
  en: en,
  pt: pt,
  ru: ru
};

const { app, setting } = useStore();


const language = computed(() => app.language);
const size: any = computed(() => app.size);

const locale = ref();
watch(
  language,
  value => {
    locale.value = languageMap[value as keyof typeof languageMap];
  },
  {
    // 初始化立即执行
    immediate: true
  }
);
console.log(window, 'window.ethereum3');
setting.getWebConfig();
setting.getEnPaymentMethods();
</script>

<style scoped lang="less"></style>
